﻿import React, { useEffect, useRef } from "react";
import { api } from "../utils/api.js";

const CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
let scriptPromise = null;

function loadGoogle() {
  if (window.google && window.google.accounts) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://accounts.google.com/gsi/client";
      s.async = true;
      s.onload = resolve;
      s.onerror = () => { scriptPromise = null; reject(new Error("load failed")); };
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

// Shows Google's own "Continue with Google" button. Renders nothing if no client ID is set.
export default function GoogleButton({ onSuccess, onError }) {
  const box = useRef(null);
  const cb = useRef({ onSuccess, onError });
  cb.current = { onSuccess, onError };

  useEffect(() => {
    if (!CLIENT_ID) return undefined;
    let dead = false;
    loadGoogle()
      .then(() => {
        if (dead || !box.current) return;
        window.google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: async (resp) => {
            try {
              const r = await api("/auth/google", { method: "POST", body: { credential: resp.credential } });
              await cb.current.onSuccess({ ...r.user, token: r.token });
            } catch (e) {
              cb.current.onError(e.message);
            }
          },
        });
        window.google.accounts.id.renderButton(box.current, { theme: "outline", size: "large", text: "continue_with", width: 300 });
      })
      .catch(() => cb.current.onError("Could not load Google sign-in. Check your internet connection."));
    return () => { dead = true; };
  }, []);

  if (!CLIENT_ID) return null;
  return (
    <div style={{ margin: "14px 0 6px" }}>
      <div style={{ display: "flex", justifyContent: "center" }} ref={box} />
      <div style={{ textAlign: "center", color: "#888", fontSize: 12, margin: "10px 0 0" }}>or use email</div>
    </div>
  );
}
